const getCollectionPageSchema = (
  canonicalUrl: string,
  name: string,
  description: string,
  locale: string,
  hostname: string,
): TMetaCollectionPage | null => {
  if (!canonicalUrl || !name) {
    return null;
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    '@id': `${canonicalUrl.replace(/\/?$/, '/')}#category`,
    name,
    description,
    url: canonicalUrl,
    inLanguage: locale,
    isPartOf: {
      '@id': `https://${hostname}/#website`,
    },
  };
};

export default getCollectionPageSchema;
